module.exports = __webpack_public_path__ + "static/media/font_medium.9f214421.woff";